module.exports = __webpack_public_path__ + "img/4.95c7b65c.jpg";